export default __webpack_public_path__ + "static/media/step6.f1eeb9c9.jpg";